module.exports = __webpack_public_path__ + "img/about-story-bg.4a1de417.png";